import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';
// import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { PROJECTS } from './mock-projects';
/*
  Generated class for the ProjectDataProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
let watchedProjects = [];

@Injectable()
export class ProjectDataProvider {

  // constructor(public http: Http) {
  constructor(){
    // console.log('Hello ProjectDataProvider Provider');
  }

  findAll() {
      /*
      return Observable.create(observer => {
          observer.next(PROJECTS);
          observer.complete();
    });*/
    return PROJECTS;
  }
  findBySearchTerm(searchTerm) {
        
        // return Observable.create(observer => {
        //     observer.next(
        return PROJECTS.filter((item) => {
                return (
                  item.description.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
                  ||
                  item.projectNumber.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
                  ||
                  item.responsibleEmployes.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
                  //||
                  //item.projectYear.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
                  );
               });
            //);
            // observer.complete();
        //});
  }

  findByProjectNumber(projectNumber : string) {
        // return Observable.create(observer => {
        //     observer.next(
        return PROJECTS.filter((item) => {
                return (
                    item.projectNumber.toLowerCase().indexOf(projectNumber.toLowerCase()) > -1
                  );
               })
            // );
            // observer.complete();
        //});
  }

  addProject(project){
    // check project
    PROJECTS.push(project);
    // return code - message channel
  }
  updateProject(project){
    // check project
    console.log("update project");
    // return code - message channel
  }

}



// WEBPACK FOOTER //
// ./src/providers/project-data-provider.ts